/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as siteRouteRouteImport } from './routes/(site)/route'
import { Route as siteIndexRouteImport } from './routes/(site)/index'
import { Route as siteTermsRouteImport } from './routes/(site)/terms'
import { Route as siteRulesRouteImport } from './routes/(site)/rules'
import { Route as siteRefundsRouteImport } from './routes/(site)/refunds'
import { Route as sitePrivacyRouteImport } from './routes/(site)/privacy'
import { Route as siteCookiesRouteImport } from './routes/(site)/cookies'
import { Route as siteCodeOfConductRouteImport } from './routes/(site)/code-of-conduct'
import { Route as siteAntiCheatingRouteImport } from './routes/(site)/anti-cheating'
import { Route as authSignUpRouteImport } from './routes/(auth)/sign-up'
import { Route as authAuthRouteImport } from './routes/(auth)/auth'
import { Route as appAppRouteRouteImport } from './routes/(app)/app/route'
import { Route as adminAdminRouteRouteImport } from './routes/(admin)/admin/route'
import { Route as appAppIndexRouteImport } from './routes/(app)/app/index'
import { Route as adminAdminIndexRouteImport } from './routes/(admin)/admin/index'
import { Route as appAppSettingsRouteImport } from './routes/(app)/app/settings'
import { Route as appAppResultsRouteRouteImport } from './routes/(app)/app/results/route'
import { Route as appAppTeamsIndexRouteImport } from './routes/(app)/app/teams/index'
import { Route as appAppResultsIndexRouteImport } from './routes/(app)/app/results/index'
import { Route as appAppQuizzesIndexRouteImport } from './routes/(app)/app/quizzes/index'
import { Route as adminAdminUsersIndexRouteImport } from './routes/(admin)/admin/users/index'
import { Route as adminAdminTeamsIndexRouteImport } from './routes/(admin)/admin/teams/index'
import { Route as adminAdminQuizzesIndexRouteImport } from './routes/(admin)/admin/quizzes/index'
import { Route as adminAdminDecksIndexRouteImport } from './routes/(admin)/admin/decks/index'
import { Route as appAppTeamsTeamIdRouteImport } from './routes/(app)/app/teams/$teamId'
import { Route as appAppStatsQuizIdRouteImport } from './routes/(app)/app/stats/$quizId'
import { Route as appAppResultsTeamsRouteImport } from './routes/(app)/app/results/teams'
import { Route as appAppResultsSpecialistRouteImport } from './routes/(app)/app/results/specialist'
import { Route as appAppResultsPairsRouteImport } from './routes/(app)/app/results/pairs'
import { Route as appAppResultsDailyRouteImport } from './routes/(app)/app/results/daily'
import { Route as appAppResultsChampionsRouteImport } from './routes/(app)/app/results/champions'
import { Route as adminAdminUsersUserIdRouteImport } from './routes/(admin)/admin/users/$userId'
import { Route as adminAdminTeamsTeamIdRouteImport } from './routes/(admin)/admin/teams/$teamId'
import { Route as adminAdminQuizzesQuizIdRouteImport } from './routes/(admin)/admin/quizzes/$quizId'
import { Route as appAppQuizzesQuizStateIdRouteRouteImport } from './routes/(app)/app/quizzes/$quizStateId/route'
import { Route as appAppQuizzesQuizStateIdIndexRouteImport } from './routes/(app)/app/quizzes/$quizStateId/index'
import { Route as adminAdminDecksDeckIdIndexRouteImport } from './routes/(admin)/admin/decks/$deckId/index'
import { Route as appAppResultsTeamsTeamIdRouteImport } from './routes/(app)/app/results/teams.$teamId'
import { Route as appAppResultsPlayersUserIdRouteImport } from './routes/(app)/app/results/players.$userId'
import { Route as appAppQuizzesQuizStateIdInstanceRouteImport } from './routes/(app)/app/quizzes/$quizStateId/instance'
import { Route as adminAdminQuizzesQuizIdQuestionsRouteImport } from './routes/(admin)/admin/quizzes/$quizId_.questions'
import { Route as adminAdminQuizzesQuizIdRoundNumberRouteImport } from './routes/(admin)/admin/quizzes/$quizId_.$roundNumber'
import { Route as appAppQuizzesQuizStateIdRoundsIndexRouteImport } from './routes/(app)/app/quizzes/$quizStateId/rounds/index'
import { Route as appAppTeamsTeamIdQuizQuizIdRouteImport } from './routes/(app)/app/teams/$teamId_.quiz.$quizId'
import { Route as appAppQuizzesQuizStateIdRoundsRoundNumberRouteImport } from './routes/(app)/app/quizzes/$quizStateId/rounds/$roundNumber'
import { Route as adminAdminQuizzesQuizIdQuestionsQuestionIdRouteImport } from './routes/(admin)/admin/quizzes/$quizId_.questions_.$questionId'

const siteRouteRoute = siteRouteRouteImport.update({
  id: '/(site)',
  getParentRoute: () => rootRouteImport,
} as any)
const siteIndexRoute = siteIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => siteRouteRoute,
} as any)
const siteTermsRoute = siteTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => siteRouteRoute,
} as any)
const siteRulesRoute = siteRulesRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => siteRouteRoute,
} as any)
const siteRefundsRoute = siteRefundsRouteImport.update({
  id: '/refunds',
  path: '/refunds',
  getParentRoute: () => siteRouteRoute,
} as any)
const sitePrivacyRoute = sitePrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => siteRouteRoute,
} as any)
const siteCookiesRoute = siteCookiesRouteImport.update({
  id: '/cookies',
  path: '/cookies',
  getParentRoute: () => siteRouteRoute,
} as any)
const siteCodeOfConductRoute = siteCodeOfConductRouteImport.update({
  id: '/code-of-conduct',
  path: '/code-of-conduct',
  getParentRoute: () => siteRouteRoute,
} as any)
const siteAntiCheatingRoute = siteAntiCheatingRouteImport.update({
  id: '/anti-cheating',
  path: '/anti-cheating',
  getParentRoute: () => siteRouteRoute,
} as any)
const authSignUpRoute = authSignUpRouteImport.update({
  id: '/(auth)/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const authAuthRoute = authAuthRouteImport.update({
  id: '/(auth)/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const appAppRouteRoute = appAppRouteRouteImport.update({
  id: '/(app)/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const adminAdminRouteRoute = adminAdminRouteRouteImport.update({
  id: '/(admin)/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const appAppIndexRoute = appAppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appAppRouteRoute,
} as any)
const adminAdminIndexRoute = adminAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => adminAdminRouteRoute,
} as any)
const appAppSettingsRoute = appAppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => appAppRouteRoute,
} as any)
const appAppResultsRouteRoute = appAppResultsRouteRouteImport.update({
  id: '/results',
  path: '/results',
  getParentRoute: () => appAppRouteRoute,
} as any)
const appAppTeamsIndexRoute = appAppTeamsIndexRouteImport.update({
  id: '/teams/',
  path: '/teams/',
  getParentRoute: () => appAppRouteRoute,
} as any)
const appAppResultsIndexRoute = appAppResultsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appAppResultsRouteRoute,
} as any)
const appAppQuizzesIndexRoute = appAppQuizzesIndexRouteImport.update({
  id: '/quizzes/',
  path: '/quizzes/',
  getParentRoute: () => appAppRouteRoute,
} as any)
const adminAdminUsersIndexRoute = adminAdminUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => adminAdminRouteRoute,
} as any)
const adminAdminTeamsIndexRoute = adminAdminTeamsIndexRouteImport.update({
  id: '/teams/',
  path: '/teams/',
  getParentRoute: () => adminAdminRouteRoute,
} as any)
const adminAdminQuizzesIndexRoute = adminAdminQuizzesIndexRouteImport.update({
  id: '/quizzes/',
  path: '/quizzes/',
  getParentRoute: () => adminAdminRouteRoute,
} as any)
const adminAdminDecksIndexRoute = adminAdminDecksIndexRouteImport.update({
  id: '/decks/',
  path: '/decks/',
  getParentRoute: () => adminAdminRouteRoute,
} as any)
const appAppTeamsTeamIdRoute = appAppTeamsTeamIdRouteImport.update({
  id: '/teams/$teamId',
  path: '/teams/$teamId',
  getParentRoute: () => appAppRouteRoute,
} as any)
const appAppStatsQuizIdRoute = appAppStatsQuizIdRouteImport.update({
  id: '/stats/$quizId',
  path: '/stats/$quizId',
  getParentRoute: () => appAppRouteRoute,
} as any)
const appAppResultsTeamsRoute = appAppResultsTeamsRouteImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => appAppResultsRouteRoute,
} as any)
const appAppResultsSpecialistRoute = appAppResultsSpecialistRouteImport.update({
  id: '/specialist',
  path: '/specialist',
  getParentRoute: () => appAppResultsRouteRoute,
} as any)
const appAppResultsPairsRoute = appAppResultsPairsRouteImport.update({
  id: '/pairs',
  path: '/pairs',
  getParentRoute: () => appAppResultsRouteRoute,
} as any)
const appAppResultsDailyRoute = appAppResultsDailyRouteImport.update({
  id: '/daily',
  path: '/daily',
  getParentRoute: () => appAppResultsRouteRoute,
} as any)
const appAppResultsChampionsRoute = appAppResultsChampionsRouteImport.update({
  id: '/champions',
  path: '/champions',
  getParentRoute: () => appAppResultsRouteRoute,
} as any)
const adminAdminUsersUserIdRoute = adminAdminUsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => adminAdminRouteRoute,
} as any)
const adminAdminTeamsTeamIdRoute = adminAdminTeamsTeamIdRouteImport.update({
  id: '/teams/$teamId',
  path: '/teams/$teamId',
  getParentRoute: () => adminAdminRouteRoute,
} as any)
const adminAdminQuizzesQuizIdRoute = adminAdminQuizzesQuizIdRouteImport.update({
  id: '/quizzes/$quizId',
  path: '/quizzes/$quizId',
  getParentRoute: () => adminAdminRouteRoute,
} as any)
const appAppQuizzesQuizStateIdRouteRoute =
  appAppQuizzesQuizStateIdRouteRouteImport.update({
    id: '/quizzes/$quizStateId',
    path: '/quizzes/$quizStateId',
    getParentRoute: () => appAppRouteRoute,
  } as any)
const appAppQuizzesQuizStateIdIndexRoute =
  appAppQuizzesQuizStateIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appAppQuizzesQuizStateIdRouteRoute,
  } as any)
const adminAdminDecksDeckIdIndexRoute =
  adminAdminDecksDeckIdIndexRouteImport.update({
    id: '/decks/$deckId/',
    path: '/decks/$deckId/',
    getParentRoute: () => adminAdminRouteRoute,
  } as any)
const appAppResultsTeamsTeamIdRoute =
  appAppResultsTeamsTeamIdRouteImport.update({
    id: '/$teamId',
    path: '/$teamId',
    getParentRoute: () => appAppResultsTeamsRoute,
  } as any)
const appAppResultsPlayersUserIdRoute =
  appAppResultsPlayersUserIdRouteImport.update({
    id: '/players/$userId',
    path: '/players/$userId',
    getParentRoute: () => appAppResultsRouteRoute,
  } as any)
const appAppQuizzesQuizStateIdInstanceRoute =
  appAppQuizzesQuizStateIdInstanceRouteImport.update({
    id: '/instance',
    path: '/instance',
    getParentRoute: () => appAppQuizzesQuizStateIdRouteRoute,
  } as any)
const adminAdminQuizzesQuizIdQuestionsRoute =
  adminAdminQuizzesQuizIdQuestionsRouteImport.update({
    id: '/quizzes/$quizId_/questions',
    path: '/quizzes/$quizId/questions',
    getParentRoute: () => adminAdminRouteRoute,
  } as any)
const adminAdminQuizzesQuizIdRoundNumberRoute =
  adminAdminQuizzesQuizIdRoundNumberRouteImport.update({
    id: '/quizzes/$quizId_/$roundNumber',
    path: '/quizzes/$quizId/$roundNumber',
    getParentRoute: () => adminAdminRouteRoute,
  } as any)
const appAppQuizzesQuizStateIdRoundsIndexRoute =
  appAppQuizzesQuizStateIdRoundsIndexRouteImport.update({
    id: '/rounds/',
    path: '/rounds/',
    getParentRoute: () => appAppQuizzesQuizStateIdRouteRoute,
  } as any)
const appAppTeamsTeamIdQuizQuizIdRoute =
  appAppTeamsTeamIdQuizQuizIdRouteImport.update({
    id: '/teams/$teamId_/quiz/$quizId',
    path: '/teams/$teamId/quiz/$quizId',
    getParentRoute: () => appAppRouteRoute,
  } as any)
const appAppQuizzesQuizStateIdRoundsRoundNumberRoute =
  appAppQuizzesQuizStateIdRoundsRoundNumberRouteImport.update({
    id: '/rounds/$roundNumber',
    path: '/rounds/$roundNumber',
    getParentRoute: () => appAppQuizzesQuizStateIdRouteRoute,
  } as any)
const adminAdminQuizzesQuizIdQuestionsQuestionIdRoute =
  adminAdminQuizzesQuizIdQuestionsQuestionIdRouteImport.update({
    id: '/quizzes/$quizId_/questions_/$questionId',
    path: '/quizzes/$quizId/questions/$questionId',
    getParentRoute: () => adminAdminRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/admin': typeof adminAdminRouteRouteWithChildren
  '/app': typeof appAppRouteRouteWithChildren
  '/auth': typeof authAuthRoute
  '/sign-up': typeof authSignUpRoute
  '/anti-cheating': typeof siteAntiCheatingRoute
  '/code-of-conduct': typeof siteCodeOfConductRoute
  '/cookies': typeof siteCookiesRoute
  '/privacy': typeof sitePrivacyRoute
  '/refunds': typeof siteRefundsRoute
  '/rules': typeof siteRulesRoute
  '/terms': typeof siteTermsRoute
  '/': typeof siteIndexRoute
  '/app/results': typeof appAppResultsRouteRouteWithChildren
  '/app/settings': typeof appAppSettingsRoute
  '/admin/': typeof adminAdminIndexRoute
  '/app/': typeof appAppIndexRoute
  '/app/quizzes/$quizStateId': typeof appAppQuizzesQuizStateIdRouteRouteWithChildren
  '/admin/quizzes/$quizId': typeof adminAdminQuizzesQuizIdRoute
  '/admin/teams/$teamId': typeof adminAdminTeamsTeamIdRoute
  '/admin/users/$userId': typeof adminAdminUsersUserIdRoute
  '/app/results/champions': typeof appAppResultsChampionsRoute
  '/app/results/daily': typeof appAppResultsDailyRoute
  '/app/results/pairs': typeof appAppResultsPairsRoute
  '/app/results/specialist': typeof appAppResultsSpecialistRoute
  '/app/results/teams': typeof appAppResultsTeamsRouteWithChildren
  '/app/stats/$quizId': typeof appAppStatsQuizIdRoute
  '/app/teams/$teamId': typeof appAppTeamsTeamIdRoute
  '/admin/decks': typeof adminAdminDecksIndexRoute
  '/admin/quizzes': typeof adminAdminQuizzesIndexRoute
  '/admin/teams': typeof adminAdminTeamsIndexRoute
  '/admin/users': typeof adminAdminUsersIndexRoute
  '/app/quizzes': typeof appAppQuizzesIndexRoute
  '/app/results/': typeof appAppResultsIndexRoute
  '/app/teams': typeof appAppTeamsIndexRoute
  '/admin/quizzes/$quizId/$roundNumber': typeof adminAdminQuizzesQuizIdRoundNumberRoute
  '/admin/quizzes/$quizId/questions': typeof adminAdminQuizzesQuizIdQuestionsRoute
  '/app/quizzes/$quizStateId/instance': typeof appAppQuizzesQuizStateIdInstanceRoute
  '/app/results/players/$userId': typeof appAppResultsPlayersUserIdRoute
  '/app/results/teams/$teamId': typeof appAppResultsTeamsTeamIdRoute
  '/admin/decks/$deckId': typeof adminAdminDecksDeckIdIndexRoute
  '/app/quizzes/$quizStateId/': typeof appAppQuizzesQuizStateIdIndexRoute
  '/admin/quizzes/$quizId/questions/$questionId': typeof adminAdminQuizzesQuizIdQuestionsQuestionIdRoute
  '/app/quizzes/$quizStateId/rounds/$roundNumber': typeof appAppQuizzesQuizStateIdRoundsRoundNumberRoute
  '/app/teams/$teamId/quiz/$quizId': typeof appAppTeamsTeamIdQuizQuizIdRoute
  '/app/quizzes/$quizStateId/rounds': typeof appAppQuizzesQuizStateIdRoundsIndexRoute
}
export interface FileRoutesByTo {
  '/auth': typeof authAuthRoute
  '/sign-up': typeof authSignUpRoute
  '/anti-cheating': typeof siteAntiCheatingRoute
  '/code-of-conduct': typeof siteCodeOfConductRoute
  '/cookies': typeof siteCookiesRoute
  '/privacy': typeof sitePrivacyRoute
  '/refunds': typeof siteRefundsRoute
  '/rules': typeof siteRulesRoute
  '/terms': typeof siteTermsRoute
  '/': typeof siteIndexRoute
  '/app/settings': typeof appAppSettingsRoute
  '/admin': typeof adminAdminIndexRoute
  '/app': typeof appAppIndexRoute
  '/admin/quizzes/$quizId': typeof adminAdminQuizzesQuizIdRoute
  '/admin/teams/$teamId': typeof adminAdminTeamsTeamIdRoute
  '/admin/users/$userId': typeof adminAdminUsersUserIdRoute
  '/app/results/champions': typeof appAppResultsChampionsRoute
  '/app/results/daily': typeof appAppResultsDailyRoute
  '/app/results/pairs': typeof appAppResultsPairsRoute
  '/app/results/specialist': typeof appAppResultsSpecialistRoute
  '/app/results/teams': typeof appAppResultsTeamsRouteWithChildren
  '/app/stats/$quizId': typeof appAppStatsQuizIdRoute
  '/app/teams/$teamId': typeof appAppTeamsTeamIdRoute
  '/admin/decks': typeof adminAdminDecksIndexRoute
  '/admin/quizzes': typeof adminAdminQuizzesIndexRoute
  '/admin/teams': typeof adminAdminTeamsIndexRoute
  '/admin/users': typeof adminAdminUsersIndexRoute
  '/app/quizzes': typeof appAppQuizzesIndexRoute
  '/app/results': typeof appAppResultsIndexRoute
  '/app/teams': typeof appAppTeamsIndexRoute
  '/admin/quizzes/$quizId/$roundNumber': typeof adminAdminQuizzesQuizIdRoundNumberRoute
  '/admin/quizzes/$quizId/questions': typeof adminAdminQuizzesQuizIdQuestionsRoute
  '/app/quizzes/$quizStateId/instance': typeof appAppQuizzesQuizStateIdInstanceRoute
  '/app/results/players/$userId': typeof appAppResultsPlayersUserIdRoute
  '/app/results/teams/$teamId': typeof appAppResultsTeamsTeamIdRoute
  '/admin/decks/$deckId': typeof adminAdminDecksDeckIdIndexRoute
  '/app/quizzes/$quizStateId': typeof appAppQuizzesQuizStateIdIndexRoute
  '/admin/quizzes/$quizId/questions/$questionId': typeof adminAdminQuizzesQuizIdQuestionsQuestionIdRoute
  '/app/quizzes/$quizStateId/rounds/$roundNumber': typeof appAppQuizzesQuizStateIdRoundsRoundNumberRoute
  '/app/teams/$teamId/quiz/$quizId': typeof appAppTeamsTeamIdQuizQuizIdRoute
  '/app/quizzes/$quizStateId/rounds': typeof appAppQuizzesQuizStateIdRoundsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(site)': typeof siteRouteRouteWithChildren
  '/(admin)/admin': typeof adminAdminRouteRouteWithChildren
  '/(app)/app': typeof appAppRouteRouteWithChildren
  '/(auth)/auth': typeof authAuthRoute
  '/(auth)/sign-up': typeof authSignUpRoute
  '/(site)/anti-cheating': typeof siteAntiCheatingRoute
  '/(site)/code-of-conduct': typeof siteCodeOfConductRoute
  '/(site)/cookies': typeof siteCookiesRoute
  '/(site)/privacy': typeof sitePrivacyRoute
  '/(site)/refunds': typeof siteRefundsRoute
  '/(site)/rules': typeof siteRulesRoute
  '/(site)/terms': typeof siteTermsRoute
  '/(site)/': typeof siteIndexRoute
  '/(app)/app/results': typeof appAppResultsRouteRouteWithChildren
  '/(app)/app/settings': typeof appAppSettingsRoute
  '/(admin)/admin/': typeof adminAdminIndexRoute
  '/(app)/app/': typeof appAppIndexRoute
  '/(app)/app/quizzes/$quizStateId': typeof appAppQuizzesQuizStateIdRouteRouteWithChildren
  '/(admin)/admin/quizzes/$quizId': typeof adminAdminQuizzesQuizIdRoute
  '/(admin)/admin/teams/$teamId': typeof adminAdminTeamsTeamIdRoute
  '/(admin)/admin/users/$userId': typeof adminAdminUsersUserIdRoute
  '/(app)/app/results/champions': typeof appAppResultsChampionsRoute
  '/(app)/app/results/daily': typeof appAppResultsDailyRoute
  '/(app)/app/results/pairs': typeof appAppResultsPairsRoute
  '/(app)/app/results/specialist': typeof appAppResultsSpecialistRoute
  '/(app)/app/results/teams': typeof appAppResultsTeamsRouteWithChildren
  '/(app)/app/stats/$quizId': typeof appAppStatsQuizIdRoute
  '/(app)/app/teams/$teamId': typeof appAppTeamsTeamIdRoute
  '/(admin)/admin/decks/': typeof adminAdminDecksIndexRoute
  '/(admin)/admin/quizzes/': typeof adminAdminQuizzesIndexRoute
  '/(admin)/admin/teams/': typeof adminAdminTeamsIndexRoute
  '/(admin)/admin/users/': typeof adminAdminUsersIndexRoute
  '/(app)/app/quizzes/': typeof appAppQuizzesIndexRoute
  '/(app)/app/results/': typeof appAppResultsIndexRoute
  '/(app)/app/teams/': typeof appAppTeamsIndexRoute
  '/(admin)/admin/quizzes/$quizId_/$roundNumber': typeof adminAdminQuizzesQuizIdRoundNumberRoute
  '/(admin)/admin/quizzes/$quizId_/questions': typeof adminAdminQuizzesQuizIdQuestionsRoute
  '/(app)/app/quizzes/$quizStateId/instance': typeof appAppQuizzesQuizStateIdInstanceRoute
  '/(app)/app/results/players/$userId': typeof appAppResultsPlayersUserIdRoute
  '/(app)/app/results/teams/$teamId': typeof appAppResultsTeamsTeamIdRoute
  '/(admin)/admin/decks/$deckId/': typeof adminAdminDecksDeckIdIndexRoute
  '/(app)/app/quizzes/$quizStateId/': typeof appAppQuizzesQuizStateIdIndexRoute
  '/(admin)/admin/quizzes/$quizId_/questions_/$questionId': typeof adminAdminQuizzesQuizIdQuestionsQuestionIdRoute
  '/(app)/app/quizzes/$quizStateId/rounds/$roundNumber': typeof appAppQuizzesQuizStateIdRoundsRoundNumberRoute
  '/(app)/app/teams/$teamId_/quiz/$quizId': typeof appAppTeamsTeamIdQuizQuizIdRoute
  '/(app)/app/quizzes/$quizStateId/rounds/': typeof appAppQuizzesQuizStateIdRoundsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/admin'
    | '/app'
    | '/auth'
    | '/sign-up'
    | '/anti-cheating'
    | '/code-of-conduct'
    | '/cookies'
    | '/privacy'
    | '/refunds'
    | '/rules'
    | '/terms'
    | '/'
    | '/app/results'
    | '/app/settings'
    | '/admin/'
    | '/app/'
    | '/app/quizzes/$quizStateId'
    | '/admin/quizzes/$quizId'
    | '/admin/teams/$teamId'
    | '/admin/users/$userId'
    | '/app/results/champions'
    | '/app/results/daily'
    | '/app/results/pairs'
    | '/app/results/specialist'
    | '/app/results/teams'
    | '/app/stats/$quizId'
    | '/app/teams/$teamId'
    | '/admin/decks'
    | '/admin/quizzes'
    | '/admin/teams'
    | '/admin/users'
    | '/app/quizzes'
    | '/app/results/'
    | '/app/teams'
    | '/admin/quizzes/$quizId/$roundNumber'
    | '/admin/quizzes/$quizId/questions'
    | '/app/quizzes/$quizStateId/instance'
    | '/app/results/players/$userId'
    | '/app/results/teams/$teamId'
    | '/admin/decks/$deckId'
    | '/app/quizzes/$quizStateId/'
    | '/admin/quizzes/$quizId/questions/$questionId'
    | '/app/quizzes/$quizStateId/rounds/$roundNumber'
    | '/app/teams/$teamId/quiz/$quizId'
    | '/app/quizzes/$quizStateId/rounds'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth'
    | '/sign-up'
    | '/anti-cheating'
    | '/code-of-conduct'
    | '/cookies'
    | '/privacy'
    | '/refunds'
    | '/rules'
    | '/terms'
    | '/'
    | '/app/settings'
    | '/admin'
    | '/app'
    | '/admin/quizzes/$quizId'
    | '/admin/teams/$teamId'
    | '/admin/users/$userId'
    | '/app/results/champions'
    | '/app/results/daily'
    | '/app/results/pairs'
    | '/app/results/specialist'
    | '/app/results/teams'
    | '/app/stats/$quizId'
    | '/app/teams/$teamId'
    | '/admin/decks'
    | '/admin/quizzes'
    | '/admin/teams'
    | '/admin/users'
    | '/app/quizzes'
    | '/app/results'
    | '/app/teams'
    | '/admin/quizzes/$quizId/$roundNumber'
    | '/admin/quizzes/$quizId/questions'
    | '/app/quizzes/$quizStateId/instance'
    | '/app/results/players/$userId'
    | '/app/results/teams/$teamId'
    | '/admin/decks/$deckId'
    | '/app/quizzes/$quizStateId'
    | '/admin/quizzes/$quizId/questions/$questionId'
    | '/app/quizzes/$quizStateId/rounds/$roundNumber'
    | '/app/teams/$teamId/quiz/$quizId'
    | '/app/quizzes/$quizStateId/rounds'
  id:
    | '__root__'
    | '/(site)'
    | '/(admin)/admin'
    | '/(app)/app'
    | '/(auth)/auth'
    | '/(auth)/sign-up'
    | '/(site)/anti-cheating'
    | '/(site)/code-of-conduct'
    | '/(site)/cookies'
    | '/(site)/privacy'
    | '/(site)/refunds'
    | '/(site)/rules'
    | '/(site)/terms'
    | '/(site)/'
    | '/(app)/app/results'
    | '/(app)/app/settings'
    | '/(admin)/admin/'
    | '/(app)/app/'
    | '/(app)/app/quizzes/$quizStateId'
    | '/(admin)/admin/quizzes/$quizId'
    | '/(admin)/admin/teams/$teamId'
    | '/(admin)/admin/users/$userId'
    | '/(app)/app/results/champions'
    | '/(app)/app/results/daily'
    | '/(app)/app/results/pairs'
    | '/(app)/app/results/specialist'
    | '/(app)/app/results/teams'
    | '/(app)/app/stats/$quizId'
    | '/(app)/app/teams/$teamId'
    | '/(admin)/admin/decks/'
    | '/(admin)/admin/quizzes/'
    | '/(admin)/admin/teams/'
    | '/(admin)/admin/users/'
    | '/(app)/app/quizzes/'
    | '/(app)/app/results/'
    | '/(app)/app/teams/'
    | '/(admin)/admin/quizzes/$quizId_/$roundNumber'
    | '/(admin)/admin/quizzes/$quizId_/questions'
    | '/(app)/app/quizzes/$quizStateId/instance'
    | '/(app)/app/results/players/$userId'
    | '/(app)/app/results/teams/$teamId'
    | '/(admin)/admin/decks/$deckId/'
    | '/(app)/app/quizzes/$quizStateId/'
    | '/(admin)/admin/quizzes/$quizId_/questions_/$questionId'
    | '/(app)/app/quizzes/$quizStateId/rounds/$roundNumber'
    | '/(app)/app/teams/$teamId_/quiz/$quizId'
    | '/(app)/app/quizzes/$quizStateId/rounds/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  siteRouteRoute: typeof siteRouteRouteWithChildren
  adminAdminRouteRoute: typeof adminAdminRouteRouteWithChildren
  appAppRouteRoute: typeof appAppRouteRouteWithChildren
  authAuthRoute: typeof authAuthRoute
  authSignUpRoute: typeof authSignUpRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(site)': {
      id: '/(site)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof siteRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(site)/': {
      id: '/(site)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof siteIndexRouteImport
      parentRoute: typeof siteRouteRoute
    }
    '/(site)/terms': {
      id: '/(site)/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof siteTermsRouteImport
      parentRoute: typeof siteRouteRoute
    }
    '/(site)/rules': {
      id: '/(site)/rules'
      path: '/rules'
      fullPath: '/rules'
      preLoaderRoute: typeof siteRulesRouteImport
      parentRoute: typeof siteRouteRoute
    }
    '/(site)/refunds': {
      id: '/(site)/refunds'
      path: '/refunds'
      fullPath: '/refunds'
      preLoaderRoute: typeof siteRefundsRouteImport
      parentRoute: typeof siteRouteRoute
    }
    '/(site)/privacy': {
      id: '/(site)/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof sitePrivacyRouteImport
      parentRoute: typeof siteRouteRoute
    }
    '/(site)/cookies': {
      id: '/(site)/cookies'
      path: '/cookies'
      fullPath: '/cookies'
      preLoaderRoute: typeof siteCookiesRouteImport
      parentRoute: typeof siteRouteRoute
    }
    '/(site)/code-of-conduct': {
      id: '/(site)/code-of-conduct'
      path: '/code-of-conduct'
      fullPath: '/code-of-conduct'
      preLoaderRoute: typeof siteCodeOfConductRouteImport
      parentRoute: typeof siteRouteRoute
    }
    '/(site)/anti-cheating': {
      id: '/(site)/anti-cheating'
      path: '/anti-cheating'
      fullPath: '/anti-cheating'
      preLoaderRoute: typeof siteAntiCheatingRouteImport
      parentRoute: typeof siteRouteRoute
    }
    '/(auth)/sign-up': {
      id: '/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof authSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/auth': {
      id: '/(auth)/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof authAuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/app': {
      id: '/(app)/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof appAppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(admin)/admin': {
      id: '/(admin)/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof adminAdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/app/': {
      id: '/(app)/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof appAppIndexRouteImport
      parentRoute: typeof appAppRouteRoute
    }
    '/(admin)/admin/': {
      id: '/(admin)/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof adminAdminIndexRouteImport
      parentRoute: typeof adminAdminRouteRoute
    }
    '/(app)/app/settings': {
      id: '/(app)/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof appAppSettingsRouteImport
      parentRoute: typeof appAppRouteRoute
    }
    '/(app)/app/results': {
      id: '/(app)/app/results'
      path: '/results'
      fullPath: '/app/results'
      preLoaderRoute: typeof appAppResultsRouteRouteImport
      parentRoute: typeof appAppRouteRoute
    }
    '/(app)/app/teams/': {
      id: '/(app)/app/teams/'
      path: '/teams'
      fullPath: '/app/teams'
      preLoaderRoute: typeof appAppTeamsIndexRouteImport
      parentRoute: typeof appAppRouteRoute
    }
    '/(app)/app/results/': {
      id: '/(app)/app/results/'
      path: '/'
      fullPath: '/app/results/'
      preLoaderRoute: typeof appAppResultsIndexRouteImport
      parentRoute: typeof appAppResultsRouteRoute
    }
    '/(app)/app/quizzes/': {
      id: '/(app)/app/quizzes/'
      path: '/quizzes'
      fullPath: '/app/quizzes'
      preLoaderRoute: typeof appAppQuizzesIndexRouteImport
      parentRoute: typeof appAppRouteRoute
    }
    '/(admin)/admin/users/': {
      id: '/(admin)/admin/users/'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof adminAdminUsersIndexRouteImport
      parentRoute: typeof adminAdminRouteRoute
    }
    '/(admin)/admin/teams/': {
      id: '/(admin)/admin/teams/'
      path: '/teams'
      fullPath: '/admin/teams'
      preLoaderRoute: typeof adminAdminTeamsIndexRouteImport
      parentRoute: typeof adminAdminRouteRoute
    }
    '/(admin)/admin/quizzes/': {
      id: '/(admin)/admin/quizzes/'
      path: '/quizzes'
      fullPath: '/admin/quizzes'
      preLoaderRoute: typeof adminAdminQuizzesIndexRouteImport
      parentRoute: typeof adminAdminRouteRoute
    }
    '/(admin)/admin/decks/': {
      id: '/(admin)/admin/decks/'
      path: '/decks'
      fullPath: '/admin/decks'
      preLoaderRoute: typeof adminAdminDecksIndexRouteImport
      parentRoute: typeof adminAdminRouteRoute
    }
    '/(app)/app/teams/$teamId': {
      id: '/(app)/app/teams/$teamId'
      path: '/teams/$teamId'
      fullPath: '/app/teams/$teamId'
      preLoaderRoute: typeof appAppTeamsTeamIdRouteImport
      parentRoute: typeof appAppRouteRoute
    }
    '/(app)/app/stats/$quizId': {
      id: '/(app)/app/stats/$quizId'
      path: '/stats/$quizId'
      fullPath: '/app/stats/$quizId'
      preLoaderRoute: typeof appAppStatsQuizIdRouteImport
      parentRoute: typeof appAppRouteRoute
    }
    '/(app)/app/results/teams': {
      id: '/(app)/app/results/teams'
      path: '/teams'
      fullPath: '/app/results/teams'
      preLoaderRoute: typeof appAppResultsTeamsRouteImport
      parentRoute: typeof appAppResultsRouteRoute
    }
    '/(app)/app/results/specialist': {
      id: '/(app)/app/results/specialist'
      path: '/specialist'
      fullPath: '/app/results/specialist'
      preLoaderRoute: typeof appAppResultsSpecialistRouteImport
      parentRoute: typeof appAppResultsRouteRoute
    }
    '/(app)/app/results/pairs': {
      id: '/(app)/app/results/pairs'
      path: '/pairs'
      fullPath: '/app/results/pairs'
      preLoaderRoute: typeof appAppResultsPairsRouteImport
      parentRoute: typeof appAppResultsRouteRoute
    }
    '/(app)/app/results/daily': {
      id: '/(app)/app/results/daily'
      path: '/daily'
      fullPath: '/app/results/daily'
      preLoaderRoute: typeof appAppResultsDailyRouteImport
      parentRoute: typeof appAppResultsRouteRoute
    }
    '/(app)/app/results/champions': {
      id: '/(app)/app/results/champions'
      path: '/champions'
      fullPath: '/app/results/champions'
      preLoaderRoute: typeof appAppResultsChampionsRouteImport
      parentRoute: typeof appAppResultsRouteRoute
    }
    '/(admin)/admin/users/$userId': {
      id: '/(admin)/admin/users/$userId'
      path: '/users/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof adminAdminUsersUserIdRouteImport
      parentRoute: typeof adminAdminRouteRoute
    }
    '/(admin)/admin/teams/$teamId': {
      id: '/(admin)/admin/teams/$teamId'
      path: '/teams/$teamId'
      fullPath: '/admin/teams/$teamId'
      preLoaderRoute: typeof adminAdminTeamsTeamIdRouteImport
      parentRoute: typeof adminAdminRouteRoute
    }
    '/(admin)/admin/quizzes/$quizId': {
      id: '/(admin)/admin/quizzes/$quizId'
      path: '/quizzes/$quizId'
      fullPath: '/admin/quizzes/$quizId'
      preLoaderRoute: typeof adminAdminQuizzesQuizIdRouteImport
      parentRoute: typeof adminAdminRouteRoute
    }
    '/(app)/app/quizzes/$quizStateId': {
      id: '/(app)/app/quizzes/$quizStateId'
      path: '/quizzes/$quizStateId'
      fullPath: '/app/quizzes/$quizStateId'
      preLoaderRoute: typeof appAppQuizzesQuizStateIdRouteRouteImport
      parentRoute: typeof appAppRouteRoute
    }
    '/(app)/app/quizzes/$quizStateId/': {
      id: '/(app)/app/quizzes/$quizStateId/'
      path: '/'
      fullPath: '/app/quizzes/$quizStateId/'
      preLoaderRoute: typeof appAppQuizzesQuizStateIdIndexRouteImport
      parentRoute: typeof appAppQuizzesQuizStateIdRouteRoute
    }
    '/(admin)/admin/decks/$deckId/': {
      id: '/(admin)/admin/decks/$deckId/'
      path: '/decks/$deckId'
      fullPath: '/admin/decks/$deckId'
      preLoaderRoute: typeof adminAdminDecksDeckIdIndexRouteImport
      parentRoute: typeof adminAdminRouteRoute
    }
    '/(app)/app/results/teams/$teamId': {
      id: '/(app)/app/results/teams/$teamId'
      path: '/$teamId'
      fullPath: '/app/results/teams/$teamId'
      preLoaderRoute: typeof appAppResultsTeamsTeamIdRouteImport
      parentRoute: typeof appAppResultsTeamsRoute
    }
    '/(app)/app/results/players/$userId': {
      id: '/(app)/app/results/players/$userId'
      path: '/players/$userId'
      fullPath: '/app/results/players/$userId'
      preLoaderRoute: typeof appAppResultsPlayersUserIdRouteImport
      parentRoute: typeof appAppResultsRouteRoute
    }
    '/(app)/app/quizzes/$quizStateId/instance': {
      id: '/(app)/app/quizzes/$quizStateId/instance'
      path: '/instance'
      fullPath: '/app/quizzes/$quizStateId/instance'
      preLoaderRoute: typeof appAppQuizzesQuizStateIdInstanceRouteImport
      parentRoute: typeof appAppQuizzesQuizStateIdRouteRoute
    }
    '/(admin)/admin/quizzes/$quizId_/questions': {
      id: '/(admin)/admin/quizzes/$quizId_/questions'
      path: '/quizzes/$quizId/questions'
      fullPath: '/admin/quizzes/$quizId/questions'
      preLoaderRoute: typeof adminAdminQuizzesQuizIdQuestionsRouteImport
      parentRoute: typeof adminAdminRouteRoute
    }
    '/(admin)/admin/quizzes/$quizId_/$roundNumber': {
      id: '/(admin)/admin/quizzes/$quizId_/$roundNumber'
      path: '/quizzes/$quizId/$roundNumber'
      fullPath: '/admin/quizzes/$quizId/$roundNumber'
      preLoaderRoute: typeof adminAdminQuizzesQuizIdRoundNumberRouteImport
      parentRoute: typeof adminAdminRouteRoute
    }
    '/(app)/app/quizzes/$quizStateId/rounds/': {
      id: '/(app)/app/quizzes/$quizStateId/rounds/'
      path: '/rounds'
      fullPath: '/app/quizzes/$quizStateId/rounds'
      preLoaderRoute: typeof appAppQuizzesQuizStateIdRoundsIndexRouteImport
      parentRoute: typeof appAppQuizzesQuizStateIdRouteRoute
    }
    '/(app)/app/teams/$teamId_/quiz/$quizId': {
      id: '/(app)/app/teams/$teamId_/quiz/$quizId'
      path: '/teams/$teamId/quiz/$quizId'
      fullPath: '/app/teams/$teamId/quiz/$quizId'
      preLoaderRoute: typeof appAppTeamsTeamIdQuizQuizIdRouteImport
      parentRoute: typeof appAppRouteRoute
    }
    '/(app)/app/quizzes/$quizStateId/rounds/$roundNumber': {
      id: '/(app)/app/quizzes/$quizStateId/rounds/$roundNumber'
      path: '/rounds/$roundNumber'
      fullPath: '/app/quizzes/$quizStateId/rounds/$roundNumber'
      preLoaderRoute: typeof appAppQuizzesQuizStateIdRoundsRoundNumberRouteImport
      parentRoute: typeof appAppQuizzesQuizStateIdRouteRoute
    }
    '/(admin)/admin/quizzes/$quizId_/questions_/$questionId': {
      id: '/(admin)/admin/quizzes/$quizId_/questions_/$questionId'
      path: '/quizzes/$quizId/questions/$questionId'
      fullPath: '/admin/quizzes/$quizId/questions/$questionId'
      preLoaderRoute: typeof adminAdminQuizzesQuizIdQuestionsQuestionIdRouteImport
      parentRoute: typeof adminAdminRouteRoute
    }
  }
}

interface siteRouteRouteChildren {
  siteAntiCheatingRoute: typeof siteAntiCheatingRoute
  siteCodeOfConductRoute: typeof siteCodeOfConductRoute
  siteCookiesRoute: typeof siteCookiesRoute
  sitePrivacyRoute: typeof sitePrivacyRoute
  siteRefundsRoute: typeof siteRefundsRoute
  siteRulesRoute: typeof siteRulesRoute
  siteTermsRoute: typeof siteTermsRoute
  siteIndexRoute: typeof siteIndexRoute
}

const siteRouteRouteChildren: siteRouteRouteChildren = {
  siteAntiCheatingRoute: siteAntiCheatingRoute,
  siteCodeOfConductRoute: siteCodeOfConductRoute,
  siteCookiesRoute: siteCookiesRoute,
  sitePrivacyRoute: sitePrivacyRoute,
  siteRefundsRoute: siteRefundsRoute,
  siteRulesRoute: siteRulesRoute,
  siteTermsRoute: siteTermsRoute,
  siteIndexRoute: siteIndexRoute,
}

const siteRouteRouteWithChildren = siteRouteRoute._addFileChildren(
  siteRouteRouteChildren,
)

interface adminAdminRouteRouteChildren {
  adminAdminIndexRoute: typeof adminAdminIndexRoute
  adminAdminQuizzesQuizIdRoute: typeof adminAdminQuizzesQuizIdRoute
  adminAdminTeamsTeamIdRoute: typeof adminAdminTeamsTeamIdRoute
  adminAdminUsersUserIdRoute: typeof adminAdminUsersUserIdRoute
  adminAdminDecksIndexRoute: typeof adminAdminDecksIndexRoute
  adminAdminQuizzesIndexRoute: typeof adminAdminQuizzesIndexRoute
  adminAdminTeamsIndexRoute: typeof adminAdminTeamsIndexRoute
  adminAdminUsersIndexRoute: typeof adminAdminUsersIndexRoute
  adminAdminQuizzesQuizIdRoundNumberRoute: typeof adminAdminQuizzesQuizIdRoundNumberRoute
  adminAdminQuizzesQuizIdQuestionsRoute: typeof adminAdminQuizzesQuizIdQuestionsRoute
  adminAdminDecksDeckIdIndexRoute: typeof adminAdminDecksDeckIdIndexRoute
  adminAdminQuizzesQuizIdQuestionsQuestionIdRoute: typeof adminAdminQuizzesQuizIdQuestionsQuestionIdRoute
}

const adminAdminRouteRouteChildren: adminAdminRouteRouteChildren = {
  adminAdminIndexRoute: adminAdminIndexRoute,
  adminAdminQuizzesQuizIdRoute: adminAdminQuizzesQuizIdRoute,
  adminAdminTeamsTeamIdRoute: adminAdminTeamsTeamIdRoute,
  adminAdminUsersUserIdRoute: adminAdminUsersUserIdRoute,
  adminAdminDecksIndexRoute: adminAdminDecksIndexRoute,
  adminAdminQuizzesIndexRoute: adminAdminQuizzesIndexRoute,
  adminAdminTeamsIndexRoute: adminAdminTeamsIndexRoute,
  adminAdminUsersIndexRoute: adminAdminUsersIndexRoute,
  adminAdminQuizzesQuizIdRoundNumberRoute:
    adminAdminQuizzesQuizIdRoundNumberRoute,
  adminAdminQuizzesQuizIdQuestionsRoute: adminAdminQuizzesQuizIdQuestionsRoute,
  adminAdminDecksDeckIdIndexRoute: adminAdminDecksDeckIdIndexRoute,
  adminAdminQuizzesQuizIdQuestionsQuestionIdRoute:
    adminAdminQuizzesQuizIdQuestionsQuestionIdRoute,
}

const adminAdminRouteRouteWithChildren = adminAdminRouteRoute._addFileChildren(
  adminAdminRouteRouteChildren,
)

interface appAppResultsTeamsRouteChildren {
  appAppResultsTeamsTeamIdRoute: typeof appAppResultsTeamsTeamIdRoute
}

const appAppResultsTeamsRouteChildren: appAppResultsTeamsRouteChildren = {
  appAppResultsTeamsTeamIdRoute: appAppResultsTeamsTeamIdRoute,
}

const appAppResultsTeamsRouteWithChildren =
  appAppResultsTeamsRoute._addFileChildren(appAppResultsTeamsRouteChildren)

interface appAppResultsRouteRouteChildren {
  appAppResultsChampionsRoute: typeof appAppResultsChampionsRoute
  appAppResultsDailyRoute: typeof appAppResultsDailyRoute
  appAppResultsPairsRoute: typeof appAppResultsPairsRoute
  appAppResultsSpecialistRoute: typeof appAppResultsSpecialistRoute
  appAppResultsTeamsRoute: typeof appAppResultsTeamsRouteWithChildren
  appAppResultsIndexRoute: typeof appAppResultsIndexRoute
  appAppResultsPlayersUserIdRoute: typeof appAppResultsPlayersUserIdRoute
}

const appAppResultsRouteRouteChildren: appAppResultsRouteRouteChildren = {
  appAppResultsChampionsRoute: appAppResultsChampionsRoute,
  appAppResultsDailyRoute: appAppResultsDailyRoute,
  appAppResultsPairsRoute: appAppResultsPairsRoute,
  appAppResultsSpecialistRoute: appAppResultsSpecialistRoute,
  appAppResultsTeamsRoute: appAppResultsTeamsRouteWithChildren,
  appAppResultsIndexRoute: appAppResultsIndexRoute,
  appAppResultsPlayersUserIdRoute: appAppResultsPlayersUserIdRoute,
}

const appAppResultsRouteRouteWithChildren =
  appAppResultsRouteRoute._addFileChildren(appAppResultsRouteRouteChildren)

interface appAppQuizzesQuizStateIdRouteRouteChildren {
  appAppQuizzesQuizStateIdInstanceRoute: typeof appAppQuizzesQuizStateIdInstanceRoute
  appAppQuizzesQuizStateIdIndexRoute: typeof appAppQuizzesQuizStateIdIndexRoute
  appAppQuizzesQuizStateIdRoundsRoundNumberRoute: typeof appAppQuizzesQuizStateIdRoundsRoundNumberRoute
  appAppQuizzesQuizStateIdRoundsIndexRoute: typeof appAppQuizzesQuizStateIdRoundsIndexRoute
}

const appAppQuizzesQuizStateIdRouteRouteChildren: appAppQuizzesQuizStateIdRouteRouteChildren =
  {
    appAppQuizzesQuizStateIdInstanceRoute:
      appAppQuizzesQuizStateIdInstanceRoute,
    appAppQuizzesQuizStateIdIndexRoute: appAppQuizzesQuizStateIdIndexRoute,
    appAppQuizzesQuizStateIdRoundsRoundNumberRoute:
      appAppQuizzesQuizStateIdRoundsRoundNumberRoute,
    appAppQuizzesQuizStateIdRoundsIndexRoute:
      appAppQuizzesQuizStateIdRoundsIndexRoute,
  }

const appAppQuizzesQuizStateIdRouteRouteWithChildren =
  appAppQuizzesQuizStateIdRouteRoute._addFileChildren(
    appAppQuizzesQuizStateIdRouteRouteChildren,
  )

interface appAppRouteRouteChildren {
  appAppResultsRouteRoute: typeof appAppResultsRouteRouteWithChildren
  appAppSettingsRoute: typeof appAppSettingsRoute
  appAppIndexRoute: typeof appAppIndexRoute
  appAppQuizzesQuizStateIdRouteRoute: typeof appAppQuizzesQuizStateIdRouteRouteWithChildren
  appAppStatsQuizIdRoute: typeof appAppStatsQuizIdRoute
  appAppTeamsTeamIdRoute: typeof appAppTeamsTeamIdRoute
  appAppQuizzesIndexRoute: typeof appAppQuizzesIndexRoute
  appAppTeamsIndexRoute: typeof appAppTeamsIndexRoute
  appAppTeamsTeamIdQuizQuizIdRoute: typeof appAppTeamsTeamIdQuizQuizIdRoute
}

const appAppRouteRouteChildren: appAppRouteRouteChildren = {
  appAppResultsRouteRoute: appAppResultsRouteRouteWithChildren,
  appAppSettingsRoute: appAppSettingsRoute,
  appAppIndexRoute: appAppIndexRoute,
  appAppQuizzesQuizStateIdRouteRoute:
    appAppQuizzesQuizStateIdRouteRouteWithChildren,
  appAppStatsQuizIdRoute: appAppStatsQuizIdRoute,
  appAppTeamsTeamIdRoute: appAppTeamsTeamIdRoute,
  appAppQuizzesIndexRoute: appAppQuizzesIndexRoute,
  appAppTeamsIndexRoute: appAppTeamsIndexRoute,
  appAppTeamsTeamIdQuizQuizIdRoute: appAppTeamsTeamIdQuizQuizIdRoute,
}

const appAppRouteRouteWithChildren = appAppRouteRoute._addFileChildren(
  appAppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  siteRouteRoute: siteRouteRouteWithChildren,
  adminAdminRouteRoute: adminAdminRouteRouteWithChildren,
  appAppRouteRoute: appAppRouteRouteWithChildren,
  authAuthRoute: authAuthRoute,
  authSignUpRoute: authSignUpRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
